<template>
  <span>
    <span v-if="!isAddingFilm">
      <v-icon class="ml-1" :small="smallIcon" :color="getIconColor('film')" v-if="!anyFidConnection" @click="addFid">
        add
      </v-icon>
    </span>
    <span v-else>
      <v-progress-circular indeterminate :color="getIconColor('film')" :width="3"></v-progress-circular>
    </span>
    <span>
      <v-icon :disabled="isAddingFilm" class="ml-1" :small="smallIcon" :color="getIconColor('film')"
        v-if="anyFidConnection" @click="editFid">
        edit
      </v-icon>
    </span>

    <Reason v-if="anyFidConnection" compressed :reason="patchReason"></Reason>
  </span>
</template>
<script>
// use this to connect a film on vimeo to a film on filmid
import { vxMaps } from "@/js/vxstore";
import { settings, getIconColor } from '@/js/store'
import Reason from '@/components/Reason'
import { SearchUtils } from '@/js'
import { showToaster, mutate } from '@/js/apollo'
import { createFilm, makeVimeoFilmMaster, provokeViLabel, Controls, removeFilm } from '@/gql'
import { mergeControls } from '@/js/apollo'
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    matchReason: {
      type: Object,
      required: true,
    },
  },
  components: {
    Reason,
  },
  methods: {

    addFilm() {
      return mutate({
        mutation: createFilm,
        variables: {
          input: {
            filmName: this.usefulVideo.filmName,
            synopsis: this.usefulVideo.synopsis,
            hidden: false
          },
        },
      }).then((r) => r && r.data && r.data.createFilm)
    },

    deleteFilm(id) {
      return mutate({
        mutation: removeFilm,
        variables: { id }
      }).then((r) => r && r.data && r.data.createFilm)
    },

    addFilmMaster(film) {
      return mutate({
        mutation: makeVimeoFilmMaster,
        variables: {
          videoID: this.usefulVideo.videoID,
          filmID: film.id,
        },
      }).then((r) => {
        const master = r && r.data && r.data.makeVimeoFilmMaster
        if (master && master.id && this.Controls.autoFilmLabelling) {
          // now kick of labelling on this
          // it's not done here by the API -
          showToaster({
            type: 'success',
            header: 'success',
            message: `Analyzing ${film.filmName} in the background`
          })

          return mutate({
            mutation: provokeViLabel,
            variables: {
              input: {
                filmMasterID: master.id
              },
            },
          }).then(() => {
            return master
          })

        } else {
          return master
        }

      })
    },

    stopPlaying() {
      mergeControls({
        playing: '',
      })
    },
    getDialog() {
      if (this.Controls.createVerification) {
        return this.$dialog.confirm(
          {
            title: 'Submit vimeo film to FilmID for qualification',
            body: `Create ${this.usefulVideo.filmName} - are you sure ?`,
          },
          {
            okText: 'Create',
            loader: true,
            cancelText: 'Cancel',
            animation: 'fade',
          })
      } else {
        return Promise.resolve(null)
      }
    },
    addFid() {
      const self = this
      // turning off createverification skips haveing to agree to creating the film for adding loads of films more easily
      this.getDialog().then((dialog) => {
        // this will generate a film
        // create a filmmaster plus all its media
        // then go there
        self.addAddedFilm({ videoID: self.usefulVideo.videoID })
        return self.addFilm()
          .then((film) => {
            self.setAddedFilm({
              videoID: self.usefulVideo.videoID,
              filmID: film.id
            })
            if (dialog) dialog.close()
            return Promise.all([film, self.addFilmMaster(film)])
          })
          .then(([film, master]) => {
            const reason = {
              matchType: 'film',
              matchID: film.id,
              match: film.filmName,
            }

            this.setAddedFilm({
              videoID: self.usefulVideo.videoID,
              filmID: master.filmID,
              filmMasterID: master.id,
              ready: true
            })

            // now change route to new film
            // if all is good, then it should show labelling under way
            if (this.Controls.vimeoNavigateAfterAdd) {
              self.stopPlaying()
              return SearchUtils.routeChange({
                router: self.$router,
                reason,
                editing: 'vimeofilm',
                hostID: self.usefulVideo.videoID,
                hostType: 'vimeo',
              })
            } else {
              showToaster({
                type: 'success',
                header: 'success',
                message: `Added ${this.usefulVideo.filmName}`
              })
            }
          })
      })
        .catch((err) => {

          if (err) {
            // delete film if it was added
            const m = this.addedFilms.find(f => f.videoID === self.usefulVideo.videoID)
            if (m && m.filmID) self.deleteFilm(m.filmID)

            showToaster({
              header: 'Something went wrong - please fix and try again',
              type: 'error',
              message: err,
              error: err,
            })
          } else {
            console.log(err, 'Clicked on cancel')
          }
        }).then(() => {
          // remove the film being added from the register
          self.removeAddedFilm({ videoID: self.usefulVideo.videoID })
        })

    },
    editFid() {
      this.stopPlaying()
      SearchUtils.routeChange({
        router: this.$router,
        reason: this.patchReason,
        editing: 'vimeofilm',
        hostID: this.matchReason && this.matchReason.matchID,
        hostType: 'vimeo',
      })
    },
    getIconColor(itemType) {
      return getIconColor(itemType)
    },
    ...mapMutations(vxMaps.mutations),
  },
  computed: {
    showingVideoID() {
      return this.vimeoUserVideo && this.vimeoUserVideo.id
    },
    isAddingFilm() {
      return Boolean(this.showingVideoID && this.addedFilms.find(f => this.showingVideoID === f.videoID))
    },
    usefulVideo() {
      return (
        this.vimeoUserVideo && {
          videoID: this.vimeoUserVideo.id,
          filmName:
            this.vimeoUserVideo.name ||
            `Vimeo film - id ${this.vimeoUserVideo.id}`,
          synopsis: this.vimeoUserVideo.description || null,
        }
      )
    },
    patchReason() {
      // this is needed to be able to route to a fid film detail if its chip is clicked
      const patch = SearchUtils.makeSearcherFilmFromVimeoSearcher(
        this.matchReason,
      )
      return patch && patch.itemReason
    },
    smallIcon() {
      return this.$vuetify.breakpoint.smAndDown
    },
    iconSize() {
      return this.smallIcon
        ? settings.dimensions.blobIconSm
        : settings.dimensions.blobIconNormal
    },
    anyFidConnection() {
      return this.areFidFilmMasters || this.areFidFilmFilesFromMd5
    },
    vimeoUserVideo() {
      return this.matchReason && this.matchReason.VimeoUserVideo
    },
    filmMastersFromVimeoID() {
      return (
        this.vimeoUserVideo &&
        this.vimeoUserVideo &&
        this.vimeoUserVideo.FilmMastersFromVimeoID
      )
    },
    areFidFilmMasters() {
      return this.filmMastersFromVimeoID && this.filmMastersFromVimeoID.length
    },
    vimeoFilmFiles() {
      return (
        this.vimeoUserVideo &&
        this.vimeoUserVideo.files &&
        this.vimeoUserVideo.files.length &&
        this.vimeoUserVideo.files
      )
    },
    filmFilesFromMd5() {
      return (
        this.vimeoFilmFiles &&
        this.vimeoFilmFiles.length &&
        this.vimeoFilmFiles
          .map((f) => f.FilmFilesFromMd5)
          .filter((f) => f && f.length)
      )
    },
    areFidFilmFilesFromMd5() {
      return this.filmFilesFromMd5 && this.filmFilesFromMd5.length
    },
    ...mapState(vxMaps.state),
  },
  apollo: {
    Controls: {
      query: Controls
    },
  }
}
</script>
